import Header from '@/components/common/Header'
import ChangePasswordModal from '@/components/myPage/ChangePasswordModal'
import WithdrawModal from '@/components/myPage/WithdrawModal'
import { useAuthContext } from '@/context/AuthContext'
import { useModal } from '@/hooks/useModal'
import { formatE164ForDisplay, formatPhoneNumber } from '@/utils/formatter/utils'
import styled from '@emotion/styled'
import { Avatar, Button, Flex, Text } from '@collable/ui'

const MyPage = () => {
  const { me, actions } = useAuthContext()
  const { opened: changePasswordOpened, toggleModal: toggleChangePasswordModal } = useModal()
  const { opened: withdrawOpened, toggleModal: toggleWithdrawModal } = useModal()

  const onClickChangePassword = () => {
    toggleChangePasswordModal()
  }

  const onClickWithdraw = () => {
    toggleWithdrawModal()
  }

  return (
    <Container>
      <Header />
      <MainContent direction="column" gap={32}>
        <UserInfo gap={10} alignItems="center">
          <Avatar size="l" type="person" />
          <Text size="body2" fontWeight="medium" color="labelNeutral">
            {me?.name}
          </Text>
        </UserInfo>
        <UserDetail direction="column" gap={20}>
          <Text size="body2" color="labelStrong" fontWeight="bold">
            내정보
          </Text>

          <Flex direction="column" gap={12} as="ul">
            <Flex as="li" alignItems="center" justifyContent="space-between">
              <Text color="labelAssistive" size="body2" fontWeight="medium">
                이메일 주소
              </Text>
              <Text color="labelNormal" size="body2" fontWeight="medium">
                {me?.email}
              </Text>
            </Flex>
            {me?.authType === 'EMAIL_PASSWORD' && (
              <Flex as="li" alignItems="center" justifyContent="space-between">
                <Text color="labelAssistive" size="body2" fontWeight="medium">
                  비밀번호
                </Text>
                <button onClick={onClickChangePassword}>
                  <Text
                    color="labelNormal"
                    size="body2"
                    fontWeight="medium"
                    className="changePassword"
                  >
                    비밀번호 변경
                  </Text>
                </button>
              </Flex>
            )}
            <Flex as="li" alignItems="center" justifyContent="space-between">
              <Text color="labelAssistive" size="body2" fontWeight="medium">
                이름
              </Text>
              <Text color="labelNormal" size="body2" fontWeight="medium">
                {me?.name}
              </Text>
            </Flex>
            <Flex as="li" alignItems="center" justifyContent="space-between">
              <Text color="labelAssistive" size="body2" fontWeight="medium">
                휴대전화번호
              </Text>
              <Text color="labelNormal" size="body2" fontWeight="medium">
                {me?.phone?.startsWith('+')
                  ? formatE164ForDisplay(me.phone)
                  : formatPhoneNumber(me?.phone ?? '')}
              </Text>
            </Flex>
          </Flex>
        </UserDetail>
        <LoginOutBtnContainer>
          <Button kind="outline" color="neutral" size="medium" onClick={() => actions.signOut()}>
            로그아웃
          </Button>
          <Button kind="outline" color="danger" size="medium" onClick={onClickWithdraw}>
            회원탈퇴
          </Button>
        </LoginOutBtnContainer>
      </MainContent>
      {changePasswordOpened && <ChangePasswordModal onClose={toggleChangePasswordModal} />}
      {withdrawOpened && <WithdrawModal onClose={toggleWithdrawModal} />}
    </Container>
  )
}

export default MyPage

const Container = styled.section`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.background.backgroundAlternative};
`

const MainContent = styled(Flex)`
  width: 1320px;
  margin: 0 auto;
  padding: 48px;
`

const UserInfo = styled(Flex)`
  padding-left: 8px;
`

const UserDetail = styled(Flex)`
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.common.commonWhite};

  .changePassword {
    text-decoration: underline;
  }
`

//TODO : Button 컴포넌트에서 className 속성 주입하는 코드 추가 필요
const LoginOutBtnContainer = styled.div`
  margin-left: auto;
  display: flex;
  gap: 12px;
`
